import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService {
  private templateCache: { [key: string]: string } = {};

  private readonly orderEmailTemplate = `
<html>
  <head>
    <style>
      body { font-family: Arial, sans-serif; color: #333; }
      .container { max-width: 800px; margin: 0 auto; padding: 20px; background: #fff; }
      .header { background: #4CAF50; color: white; padding: 5px 0; text-align: center; }
      .header a { color: white; text-decoration: none; }
      .order-section { background: #f9f9f9; padding: 15px; border-radius: 6px; margin: 20px 0; }
      table { width: 100%; border-collapse: collapse; font-size: 13px; }
      th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
      th { background: #f0f0f0; }
      .footer { margin-top: 30px; font-size: 12px; color: #777; text-align: center; }
      .footer a { color: #007bff; text-decoration: none; }
    </style>
  </head>
  <body>
    <div class="container">
      <div class="header">
        <h2><a href="{{companyWebsite}}">{{companyName}}</a></h2>
      </div>

      <p>Dear <strong>{{customerName}}</strong>,</p>
      <p>Thank you for your order! We are pleased to inform you that your order has been successfully processed. Below are the order details for your reference:</p>
      <div class="order-section">
        <table>
          <tr><th>Order Number</th><td>{{orderNumber}}</td></tr>
          <tr><th>Order Date</th><td>{{orderDate}}</td></tr>
          <tr><th>Bill To</th><td>{{customerName}}</td></tr>
          <tr><th>Ship To</th><td>{{shipToName}}</td></tr>
          <tr><th>Salesperson</th><td>{{salespersonName}} ({{salespersonCode}})</td></tr>
          <tr><th>Unit</th><td>{{warehouseName}}</td></tr>
          <tr><th>Order Total</th><td>{{orderTotal}}</td></tr>
          <tr>
            <th>Tax Details</th>
            <td>
              CGST: {{cgstTotal}}<br>
              SGST: {{sgstTotal}}<br>
              IGST: {{igstTotal}}<br>
              <strong>Total Tax: {{salesTaxTotal}}</strong>
            </td>
          </tr>
        </table>
      </div>

      <p>
        If you have any questions or need support, feel free to reply to this email or contact our support team at <strong>{{companyPhone}}</strong>.<br><br>
        Thank you for choosing <strong>{{companyName}}</strong>!<br><br>
        Warm regards,<br>
        {{companyName}}<br>
        <span style="white-space: nowrap;">
        📧 <a href="mailto:{{companyEmail}}">{{companyEmail}}</a> | 🌐 <a href="{{companyWebsite}}">{{companyWebsite}}</a>
        </span>
      </p>

      <div class="footer">
        <p>If you have any questions, feel free to <a href="mailto:{{companyEmail}}">contact us</a>.</p>
        <p>&copy; {{currentYear}} <a href="{{companyWebsite}}">{{companyName}}</a>. All rights reserved.</p>
        <p>Powered by <strong>Mapsoft Technologies LLP</strong> | <a href="https://www.maptechsoft.com">www.maptechsoft.com</a></p>
      </div>
    </div>
  </body>
</html>
`;

  private readonly purchaseOrderEmailTemplate = `
<html>
  <head>
    <style>
      body { font-family: Arial, sans-serif; color: #333; }
      .container { max-width: 800px; margin: 0 auto; padding: 20px; background: #fff; }
      .header { background: #4CAF50; color: white; padding: 5px 0; text-align: center; }
      .header a { color: white; text-decoration: none; }
      .order-section { background: #f9f9f9; padding: 15px; border-radius: 6px; margin: 20px 0; }
      table { width: 100%; border-collapse: collapse; font-size: 13px; }
      th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
      th { background: #f0f0f0; }
      .footer { margin-top: 30px; font-size: 12px; color: #777; text-align: center; }
      .footer a { color: #007bff; text-decoration: none; }
    </style>
  </head>
  <body>
    <div class="container">
      <div class="header">
        <h2><a href="{{companyWebsite}}">{{companyName}}</a></h2>
      </div>

      <p>Dear <strong>{{vendorName}}</strong>,</p>
      <p>We are pleased to place a purchase order with you. Below are the order details for your reference:</p>
      <div class="order-section">
        <table>
          <tr><th>Purchase Order Number</th><td>{{orderNumber}}</td></tr>
          <tr><th>Requested Date</th><td>{{requestedDate}}</td></tr>
          <tr><th>Vendor</th><td>{{vendorName}}</td></tr>
          <tr><th>Ship To</th><td>{{shipToName}}</td></tr>
          <tr><th>Unit</th><td>{{warehouseName}}</td></tr>
          <tr><th>Order Total</th><td>{{orderTotal}}</td></tr>
          <tr>
            <th>Tax Details</th>
            <td>
              CGST: {{cgstTotal}}<br>
              SGST: {{sgstTotal}}<br>
              IGST: {{igstTotal}}<br>
              <strong>Total Tax: {{taxTotal}}</strong>
            </td>
          </tr>
        </table>
      </div>

      <p>
        If you have any questions or need support, feel free to reply to this email or contact our support team at <strong>{{companyPhone}}</strong>.<br><br>
        Thank you for your continued partnership with <strong>{{companyName}}</strong>!<br><br>
        Warm regards,<br>
        <strong>{{companyName}}</strong><br>
        <span style="white-space: nowrap;">
        📧 <a href="mailto:{{companyEmail}}">{{companyEmail}}</a> | 🌐 <a href="{{companyWebsite}}">{{companyWebsite}}</a>
        </span>
      </p>

      <div class="footer">
        <p>If you have any questions, feel free to <a href="mailto:{{companyEmail}}">contact us</a>.</p>
        <p>&copy; {{currentYear}} <a href="{{companyWebsite}}">{{companyName}}</a>. All rights reserved.</p>
        <p>Powered by <strong>Mapsoft Technologies LLP</strong> | <a href="https://www.maptechsoft.com">www.maptechsoft.com</a></p>
      </div>
    </div>
  </body>
</html>
`;

  private readonly purchaseOrderReturnEmailTemplate = `
<html>
  <head>
    <style>
      body { font-family: Arial, sans-serif; color: #333; }
      .container { max-width: 800px; margin: 0 auto; padding: 20px; background: #fff; }
      .header { background: #4CAF50; color: white; padding: 5px 0; text-align: center; }
      .header a { color: white; text-decoration: none; }
      .order-section { background: #f9f9f9; padding: 15px; border-radius: 6px; margin: 20px 0; }
      table { width: 100%; border-collapse: collapse; font-size: 13px; }
      th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
      th { background: #f0f0f0; }
      .footer { margin-top: 30px; font-size: 12px; color: #777; text-align: center; }
      .footer a { color: #007bff; text-decoration: none; }
    </style>
  </head>
  <body>
    <div class="container">
      <div class="header">
        <h2><a href="{{companyWebsite}}">{{companyName}}</a></h2>
        <p>Purchase Order Return Notification</p>
      </div>

      <p>Dear <strong>{{vendorName}}</strong>,</p>
      <p>We are returning goods as per the details below. Kindly review and process accordingly:</p>

      <div class="order-section">
        <table>
          <tr><th>Return Order Number</th><td>{{orderNumber}}</td></tr>
          <tr><th>Return Date</th><td>{{returnDate}}</td></tr>
          <tr><th>Vendor</th><td>{{vendorName}}</td></tr>
          <tr><th>Ship To</th><td>{{shipToName}}</td></tr>
          <tr><th>Unit</th><td>{{warehouseName}}</td></tr>
          <tr><th>Return Total</th><td>{{orderTotal}}</td></tr>
          <tr>
            <th>Tax Breakdown</th>
            <td>
              CGST: {{cgstTotal}}<br>
              SGST: {{sgstTotal}}<br>
              IGST: {{igstTotal}}<br>
              <strong>Total Tax: {{taxTotal}}</strong>
            </td>
          </tr>
        </table>
      </div>

      <p>
        If you have any questions or need support, feel free to reply to this email or contact our support team at <strong>{{companyPhone}}</strong>.<br><br>
        Thank you for your continued partnership with <strong>{{companyName}}</strong>!<br><br>
        Warm regards,<br>
        <strong>{{companyName}}</strong><br>
        <span style="white-space: nowrap;">
          📧 <a href="mailto:{{companyEmail}}">{{companyEmail}}</a> | 🌐 <a href="{{companyWebsite}}">{{companyWebsite}}</a>
        </span>
      </p>

      <div class="footer">
        <p>If you have any questions, feel free to <a href="mailto:{{companyEmail}}">contact us</a>.</p>
        <p>&copy; {{currentYear}} <a href="{{companyWebsite}}">{{companyName}}</a>. All rights reserved.</p>
        <p>Powered by <strong>Mapsoft Technologies LLP</strong> | <a href="https://www.maptechsoft.com">www.maptechsoft.com</a></p>
      </div>
    </div>
  </body>
</html>
`;



  private readonly supportEmailTemplate = `
<html>
  <head>
    <style>
      body { font-family: Arial, sans-serif; }
      .container { max-width: 700px; margin: auto; padding: 20px; background: #f9f9f9; }
      h2 { color: #4CAF50; }
      table { width: 100%; border-collapse: collapse; margin-top: 20px; }
      th, td { text-align: left; padding: 8px; border: 1px solid #ccc; }
      th { background-color: #f0f0f0; }
    </style>
  </head>
  <body>
    <div class="container">
      <h2>New Support Request</h2>
      <table>
        <tr><th>Email</th><td>{{email}}</td></tr>
        <tr><th>Mobile</th><td>{{mobile}}</td></tr>
        <tr><th>Subject</th><td>{{subject}}</td></tr>
        <tr><th>Urgency</th><td>{{urgency}}</td></tr>
        <tr><th>Description</th><td>{{description}}</td></tr>
      </table>
      <p>If you need immediate assistance, please reach out to our team.</p>
    </div>
  </body>
</html>
`;

  private readonly leaveApplicationTemplate = `
<html>
  <head>
    <style>
      body, html { margin: 0; padding: 0; font-family: 'Segoe UI', Roboto, Arial, sans-serif; background-color: #f4f6f8; color: #333; }
      a { color: #1976d2; text-decoration: none; }
      .email-wrapper { width: 100%; padding: 40px 0; background-color: #f4f6f8; }
      .email-container { max-width: 700px; margin: auto; background: #fff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.05); }
      .email-header { background: #1976d2; text-align: center; padding: 25px 30px; color: #fff; }
      .email-body { padding: 30px; font-size: 15px; line-height: 1.6; }
      .email-body p { margin-bottom: 16px; }
      .details-table { width: 100%; border-collapse: collapse; margin-top: 20px; margin-bottom: 25px; }
      .details-table th, .details-table td { border: 1px solid #e0e0e0; padding: 12px; font-size: 14px; }
      .details-table th { background-color: #f0f3f7; text-align: left; width: 30%; color: #555; }
      .status-pill { display: inline-block; padding: 5px 12px; border-radius: 20px; font-weight: 600; font-size: 13px; color: #fff; }
      .status-Pending { background-color: #ffb74d; }
      .status-Approved { background-color: #4caf50; }
      .status-Rejected { background-color: #f44336; }
      .footer { text-align: center; font-size: 12px; color: #777; padding: 15px; background-color: #fafafa; border-top: 1px solid #eee; }
      .footer a { color: #007bff; text-decoration: none; }
    </style>
  </head>
  <body>
    <div class="email-wrapper">
      <div class="email-container">

        <div class="email-header">
          <div style="font-size:24px; font-weight:bold; font-family:Segoe UI, Arial; margin:0;">
            New Leave Application
          </div>
        </div>
        <div class="email-body">
          <p>Dear <strong>{{managerName}}</strong>,</p>
          <p><strong>{{employeeName}}</strong> (Employee ID: <strong>{{empId}}</strong>) has submitted a leave request. Please review the details below:</p>
          <table class="details-table">
            <tr><th>Leave Type</th><td>{{leaveType}}</td></tr>
            <tr><th>From Date</th><td>{{fromDate}}</td></tr>
            <tr><th>To Date</th><td>{{toDate}}</td></tr>
            <tr><th>Duration</th><td>{{leaveDuration}}</td></tr>
            <tr><th>Reason</th><td>{{reason}}</td></tr>
            <tr>
              <th>Status</th>
              <td><span class="status-pill status-{{status}}">{{status}}</span></td>
            </tr>
          </table>
          <p>To approve or reject this leave request, please log in to the <a href="mapsofterp.in">HRMS Portal</a>.</p>
        </div>
        <!-- Footer added -->
        <div class="footer">
          <p>© {{currentYear}} <a href="{{companyWebsite}}">{{companyName}}</a>. All rights reserved.</p>
          <p>If you have any questions, feel free to <a href="mailto:{{companyEmail}}">contact us</a>.</p>
          <p>Powered by <strong>Mapsoft Technologies LLP</strong> | <a href="https://www.maptechsoft.com">www.maptechsoft.com</a></p>
        </div>
      </div>
    </div>
  </body>
</html>
`;


  private readonly leaveStatusUpdateTemplate = `
<html>
  <head>
    <style>
      body,html{margin:0;padding:0;font-family:'Segoe UI',Roboto,Arial,sans-serif;background-color:#f4f6f8;color:#333;}
      a{color:#1976d2;text-decoration:none;}
      .email-wrapper{width:100%;padding:40px 0;background-color:#f4f6f8;}
      .email-container{max-width:700px;margin:auto;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 4px 12px rgba(0,0,0,0.05);}
      .email-header{background:#1976d2;color:#fff;text-align:center;padding:25px 30px;}
      .email-body{padding:30px;font-size:15px;line-height:1.6;}
      .email-body p{margin-bottom:16px;}
      .details-table{width:100%;border-collapse:collapse;margin-top:20px;margin-bottom:25px;}
      .details-table th,.details-table td{border:1px solid #e0e0e0;padding:12px;font-size:14px;}
      .details-table th{background-color:#f0f3f7;text-align:left;width:30%;color:#555;}
      .status-pill{display:inline-block;padding:5px 12px;border-radius:20px;font-weight:600;font-size:13px;color:#fff;}
      .status-Pending{background-color:#ffb74d;}
      .status-Approved{background-color:#4caf50;}
      .status-Rejected{background-color:#f44336;}
      .footer{text-align:center;font-size:12px;color:#777;padding:15px;background-color:#fafafa;border-top:1px solid #eee;}
      .footer a{color:#007bff;text-decoration:none;}
    </style>
  </head>
  <body>
    <div class="email-wrapper">
      <div class="email-container">
        <div class="email-header">
          <div style="font-size:24px; font-weight:bold; font-family:Segoe UI, Arial; margin:0;">
            Leave Status Update
          </div>
        </div>
        <div class="email-body">
          <p>Dear <strong>{{employeeName}}</strong>,</p>
          <p>Your leave request has been <strong>{{status}}</strong>. Here are the details:</p>
          <table class="details-table">
            <tr><th>Leave Type</th><td>{{leaveType}}</td></tr>
            <tr><th>From Date</th><td>{{fromDate}}</td></tr>
            <tr><th>To Date</th><td>{{toDate}}</td></tr>
            <tr><th>Duration</th><td>{{leaveDuration}}</td></tr>
            <tr><th>Reason</th><td>{{reason}}</td></tr>
            <tr><th>Reportees Reason</th><td>{{managerReason}}</td></tr>
            <tr><th>Status</th><td><span class="status-pill status-{{status}}">{{status}}</span></td></tr>
            <tr><th>Reviewed By</th><td>{{managerName}}</td></tr>
          </table>
          <p>Please contact your manager for further details if required.</p>
          <p>You can also log in to the <a href="mapsofterp.in">HRMS Portal</a> to view your leave history.</p>
        </div>
        <!-- Footer added -->
        <div class="footer">
          <p>© {{currentYear}} <a href="{{companyWebsite}}">{{companyName}}</a>. All rights reserved.</p>
          <p>If you have any questions, feel free to <a href="mailto:{{companyEmail}}">contact us</a>.</p>
          <p>Powered by <strong>Mapsoft Technologies LLP</strong> | <a href="https://www.maptechsoft.com">www.maptechsoft.com</a></p>
        </div>
      </div>
    </div>
  </body>
</html>
`;



  constructor() { }

  getTemplate(templateName: string): Observable<string> {
    if (this.templateCache[templateName]) {
      return of(this.templateCache[templateName]);
    }

    if (templateName === 'order-email-template') {
      this.templateCache[templateName] = this.orderEmailTemplate;
      return of(this.orderEmailTemplate);
    }

    if (templateName === 'purchase-order-email-template') {
      this.templateCache[templateName] = this.purchaseOrderEmailTemplate;
      return of(this.purchaseOrderEmailTemplate);
    }

    if (templateName === 'purchase-order-return-email-template') {
      this.templateCache[templateName] = this.purchaseOrderReturnEmailTemplate;
      return of(this.purchaseOrderReturnEmailTemplate);
    }

    if (templateName === 'support-email-template') {
      this.templateCache[templateName] = this.supportEmailTemplate;
      return of(this.supportEmailTemplate);
    }

    if (templateName === 'leave-application-template') {
      this.templateCache[templateName] = this.leaveApplicationTemplate;
      return of(this.leaveApplicationTemplate);
    }

    if (templateName === 'leave-status-update-template') {
      this.templateCache[templateName] = this.leaveStatusUpdateTemplate;
      return of(this.leaveStatusUpdateTemplate);
    }

    throw new Error(`Template ${templateName} not found`);
  }

  replacePlaceholders(template: string, data: any): string {
    if (!template) {
      throw new Error('Template is empty');
    }

    if (data.requestedDate && typeof data.requestedDate === 'string') {
      const parts = data.requestedDate.split('/');
      if (parts.length === 3) {
        data.requestedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
      }
    }

    let result = template;
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const regex = new RegExp(`{{${key}}}`, 'g');
        result = result.replace(regex, data[key] || '');
      }
    }
    return result;
  }
}
